export enum SprintActivityErrorCode {
  SPRINT_AND_ACTIVITY_REQUIRED = 'sprintId-and-activityId-required',
  SPRINT_AND_ISSUES_REPORTED_REQUIRED = 'sprintId-and-issuesReported-required',
  SPRINT_ACTIVITY_AND_TEAM_REQUIRED = 'sprintId-activityId-and-teamId-required',
  SPRINT_NOT_FOUND = 'sprint-not-found',
  ACTIVITY_NOT_FOUND = 'activity-not-found',
  TEAM_NOT_IN_SPRINT = 'team-not-in-sprint',
  CALL_ROOM_NOT_FOUND = 'call-room-not-found',
  ACTIVITY_HAS_NO_PAGE = 'activity-has-no-page',
  ACTIVITY_HAS_NO_SPRINT_CALL = 'activity-has-no-sprint-call',
  NOT_SPRINT_FACILITATOR = 'not-a-facilitator-of-this-sprint',
  NOT_SPRINT_PARTICIPANT = 'not-a-participant-of-this-sprint'
}
